import React from "react";

import utils from "./utils";
import classes from "./index.module.css";
import RadioButton from "../../base-components/radio-button";
import Button from "../../base-components/button";
import GreenTick from "../../assets/green-tick.svg";
import { setUserCurrentScreen } from "../../redux/action/app";
import { updateUserProfile } from "../../redux/thunk/app.thunk";
import config from "../../config";
import { openRiskQuestionnaire, openKycFail } from "../../navigators/routes";
import { useDispatch, useSelector } from "react-redux";

const Kyc2 = () => {
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.app.isLoading);
  const [activeButton, setActiveButton] = React.useState(
    "No, none of these apply"
  );

  const onSubmit = () => {
    const filter = utils.RADIO_ITEMS.filter((t) => t.label === activeButton);
    const value = filter.length > 0 ? filter[0].value : false;
    if(value){
      openKycFail();
    }else {
      dispatch(updateUserProfile({ specialSituation: value })).then(() => {
        dispatch(setUserCurrentScreen(config.routes.riskQuestionnaire));
        openRiskQuestionnaire();
      });
    }
  };

  return (
    <div className={classes.Container}>
      <div className={classes.top}>
        <h2 className={classes.Heading}>{utils.KYC_2_HEADER}</h2>
      </div>
      <div className={classes.topmiddle}>
        {utils.KYC_2_RADIO_ITEMS.map((item) => {
          return (
            <div
              style={{
                display: "flex",
                justifyContent: "flex-start",
                margin: "10px 0",
                alignItems: "center",
                width: "300px"
              }}
            >
              <img
                src={GreenTick}
                alt="green-tick"
                style={{ margin: "5px 5px 5px 0" }}
              />
              {item.label}
            </div>
          );
        })}
      </div>
      <div className={classes.middle}>
        {utils.RADIO_ITEMS.map((item) => {
          return (
            <RadioButton
              text={item.label}
              isActive={activeButton === item.label}
              setActive={setActiveButton}
            />
          );
        })}
      </div>
      <div className={classes.bottom}>
        <Button
          //spacing={{ top: "medium", bottom: "medium" }}
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            height: "50px",
            alignItems: "center",
          }}
          loading={isLoading}
          state={undefined}
          action={onSubmit}
        >
          {utils.KYC_2_BUTTON_HEADING}
        </Button>
      </div>
    </div>
  );
};

export default Kyc2;
